import { callEventListeners } from '@shared/events/callEventListeners';
import { Maker } from './buildMachine';
import { Ctx, Snap } from './core';

const typeWhiteList = new Set(['load', 'consent_granted']);

export const eligibility: Maker<Ctx, Snap, boolean> = ({ makeEffect }) => [
  makeEffect(
    'response',
    (_, { ctx, snap, pass, skip }) => {
      if (!ctx.axios.active[0]) return skip('');

      const { req, res, whenRes } = ctx.axios.active[0];

      if (!res) return skip('');
      if (!whenRes) return skip('');
      if (!req.url?.includes('mno-precheck')) return skip('');

      const url = new URL(req.url!);
      const typeParam = url.searchParams.get('type');
      if (typeParam === null) return skip('type param null');
      if (!typeWhiteList.has(typeParam)) return skip('wrong type');

      const eligibilityCheckCallResponse = ctx.axios.active[0]?.res;
      const isConnectionEligible =
        eligibilityCheckCallResponse?.status === 200 &&
        eligibilityCheckCallResponse?.data?.status === 'ok';
      const configRetryInterval =
        window.Utiq?.config?.connectionEligibilityRetryInterval;
      const isValidConfigRetryInterval =
        configRetryInterval !== undefined &&
        Number.isInteger(configRetryInterval) &&
        configRetryInterval >= 0;

      const retryInterval = isValidConfigRetryInterval
        ? configRetryInterval
        : 2;
      const isConnectionEligibilityRetryIntervalCorrect: boolean =
        Number.isInteger(retryInterval) && retryInterval >= 0;
      const connectionEligibilityCallInterval: number =
        isConnectionEligibilityRetryIntervalCorrect
          ? retryInterval * 60000
          : 120000; // 2 minutes by default

      return pass(
        {
          isEligible: isConnectionEligible,
          eligibilityCheckTime: snap.now.getTime(),
          retryEligibilityCheckTime: isConnectionEligible
            ? null
            : snap.now.getTime() + connectionEligibilityCallInterval,
        },
        'mno-precheck with valid type resolved',
      );
    },

    (utiqEligibility, { ctx }) => {
      ctx.axios.active.shift();
      callEventListeners('onEligibilityChecked', 'Utiq', {
        isEligible: utiqEligibility.isEligible,
      });
      ctx.window.localStorage.setItem(
        'utiqEligibility',
        JSON.stringify(utiqEligibility),
      );
    },
  ),
];
